import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';
import { SlotHeaderComponent } from './header/header.component';
import { SlotsRoutingModule } from './slots-routing.module';
import { ChooseSlotComponent } from './choose-slot/choose-slot.component';
import { SlotsComponent } from './slots.component';
import { SlotsService } from './slots.service';
import { SlotDataService } from './slots-data.service';
import { AddtocalenderComponent } from './addtocalender/addtocalender.component';
import { Utils } from './addtocalender/addtocalender.utils';
import { BookedSlotsComponent } from './booked-slots/booked-slots.component';
import { SlotsResolve, SlotsRescheduleResolve } from './slots.resolve';
import { HasAppointmentDetail } from '../shared/services/auth-guard.service';
import { SelectModule } from 'ng-select';
import { TimeFormatForSlots } from '../shared/pipes/TimeFormatPipeSlots';
import { ConfirmationMultiUploadComponent } from './confimation-sideBar/multi-upload/multi-upload.component';
import { ConfirmationTemplateBodyComponent } from './confimation-sideBar/confirmation-sidebar.component';
import { ClipboardModule } from 'ngx-clipboard';
import { QuillModule } from 'ngx-quill';
//import { CloudinaryModule } from '@cloudinary/angular-4.x';
//import { cloudinaryLib } from '../recruiter-cancel/recruiter-cancel.module';
import { environment } from '../../environments/environment.prod';
// import { CloudinaryWidgetModule } from '../shared/directives/cloudinary/coudinary-widget.module';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        SlotsComponent,
        SlotHeaderComponent,
        ChooseSlotComponent,
        AddtocalenderComponent,
        BookedSlotsComponent,
        ConfirmationMultiUploadComponent,
        ConfirmationTemplateBodyComponent
    ],
    imports: [
        CommonModule,  
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        SlotsRoutingModule,
        SelectModule,
        TimeFormatForSlots,
        ClipboardModule,
        QuillModule,
        // CloudinaryModule.forRoot(cloudinaryLib, {
        //     cloud_name: environment.cloudinaryConfiguration.cloud_name,
        //     upload_preset: environment.cloudinaryConfiguration.upload_preset
        //   }),
        //   CloudinaryWidgetModule,
          FileUploadModule,
          SharedModule
    ],
    providers: [
        SlotsService,
        SlotDataService,
        Utils,
        SlotsResolve,
        SlotsRescheduleResolve,
        HasAppointmentDetail
    ],
    entryComponents: [
        ConfirmationTemplateBodyComponent
    ]
})

export class SlotsModule { }


// WEBPACK FOOTER //
// ./src/app/slots/slots.module.ts